exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-dialog .el-dialog__wrapper .el-dialog__overlay[data-v-63e37709] {\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n    /* 自定义背景颜色 */\n}\r\n", ""]);

// exports
